module.exports = __webpack_public_path__ + "static/portfolio-mas-8-ebed7530ebf1aae0ff380dc00703fa60.jpg";